import React, { Component } from 'react';
import {
    Paper,
    Box,
    Typography,
    Button,
    Grid,
    Checkbox,
    Skeleton,
    Alert
} from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { apiUrl } from '../../../../comp/ApiUrl';

class MelhorEnvioSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            connected: false,
            loading: true,
            error: null,
            servicos: [],
            // Armazena a seleção dos checkboxes chaveados pelo ID do serviço
            servicosSelecionados: {}
        };
    }

    componentDidMount() {
        this.carregarServicosMelhorEnvio();
    }

    // Busca as opções de frete direto da sua API
    carregarServicosMelhorEnvio = async () => {
        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(`${apiUrl}/melhorenvio/shipment/services`, {
                credentials: 'include',
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Erro ao buscar serviços: ${response.statusText}`);
            }

            const data = await response.json();

            // Ativa por padrão todos os serviços recebidos com status 'available' (se houver serviços)
            const listaServicos = Array.isArray(data.services) ? data.services : [];
            const selecaoInicial = {};

            listaServicos.forEach((servico) => {
                selecaoInicial[servico.id] = servico.status === 'available';
            });

            this.setState({
                connected: Boolean(data.connected),
                servicos: listaServicos,
                servicosSelecionados: selecaoInicial,
                loading: false
            });
        } catch (error) {
            console.error('Erro na requisição:', error);
            this.setState({
                error: 'Não foi possível carregar os serviços do Melhor Envio.',
                loading: false
            });
        }
    };

    // Callback para conectar a conta do usuário
    handleConectarMelhorEnvio = () => {
        console.log('Redirecionando para conectar ao Melhor Envio...');
    };

    // Callback para desconectar a conta do usuário
    handleDesconectarMelhorEnvio = () => {
        console.log('Desconectando do Melhor Envio...');
    };

    // Alterna o checkbox usando o ID único do serviço
    handleTransportadoraChange = (id) => (event) => {
        const checked = event.target.checked;
        this.setState((prevState) => ({
            servicosSelecionados: {
                ...prevState.servicosSelecionados,
                [id]: checked
            }
        }));
    };

    // Renderiza o Skeleton durante o carregamento
    renderSkeletons = () => {
        return (
            <Grid container spacing={2}>
                {[1, 2, 3, 4].map((item) => (
                    <Grid item xs={12} sm={6} key={item}>
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 1.5,
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            <Skeleton variant="circular" width={24} height={24} />
                            <Box sx={{ width: '100%' }}>
                                <Skeleton variant="text" width="60%" height={20} />
                                <Skeleton variant="text" width="40%" height={16} />
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        );
    };

    render() {
        const { connected, loading, error, servicos, servicosSelecionados } = this.state;

        return (
            <Paper
                variant="outlined"
                sx={{
                    p: 3,
                    borderRadius: '16px',
                    borderColor: connected ? '#bbf7d0' : '#e9d5ff',
                    bgcolor: connected ? '#f0fdf4' : '#faf5ff',
                    mb: 4
                }}
            >
                {/* Bloco Superior de Conexão */}
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2 }}>
                    <Box
                        sx={{
                            p: 1,
                            bgcolor: connected ? '#dcfce7' : '#f3e8ff',
                            borderRadius: '8px',
                            display: 'flex',
                            mt: 0.5
                        }}
                    >
                        <FlashOnIcon sx={{ color: connected ? '#16a34a' : '#9061f9', fontSize: 20 }} />
                    </Box>
                    <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                            {connected ? 'Sua conta do Melhor Envio está conectada' : 'Conecte sua conta do Melhor Envio'}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {connected
                                ? 'Gerencie abaixo as transportadoras que estarão ativas para cotação na sua loja.'
                                : 'Use o frete real do seu contrato. Apenas transportadoras disponíveis na sua região serão exibidas para os clientes.'}
                        </Typography>
                    </Box>
                </Box>

                {/* Botão de Conectar ou Desconectar */}
                {connected ? (
                    <Button
                        fullWidth
                        variant="outlined"
                        color="error"
                        onClick={this.handleDesconectarMelhorEnvio}
                        startIcon={<LinkOffIcon />}
                        sx={{
                            py: 1.5,
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: '600',
                            fontSize: '1rem',
                            mb: 2
                        }}
                    >
                        Desconectar Melhor Envio
                    </Button>
                ) : (
                    <>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={this.handleConectarMelhorEnvio}
                            startIcon={<OpenInNewIcon />}
                            sx={{
                                py: 1.5,
                                borderRadius: '10px',
                                textTransform: 'none',
                                bgcolor: '#7e22ce',
                                fontWeight: '600',
                                fontSize: '1rem',
                                boxShadow: 'none',
                                '&:hover': { bgcolor: '#6b21a8', boxShadow: 'none' }
                            }}
                        >
                            Conectar Melhor Envio
                        </Button>

                        {/* Link criar conta (apenas quando não conectado) */}
                        <Box sx={{ textAlign: 'center', mt: 1.5, mb: 3 }}>
                            <Typography variant="caption" color="textSecondary">
                                Sem conta?{' '}
                                <a
                                    href="https://melhorenvio.com.br/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#7e22ce', textDecoration: 'underline' }}
                                >
                                    Crie grátis no Melhor Envio
                                </a>
                            </Typography>
                        </Box>
                    </>
                )}

                {/* Feedback de erro de carregamento */}
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {/* Bloco das Transportadoras (Apenas se conectado) */}
                {connected && (
                    <>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1a202c', mb: 1.5, mt: 2 }}>
                            Transportadoras habilitadas
                        </Typography>

                        {loading ? (
                            this.renderSkeletons()
                        ) : (
                            <Grid container spacing={2}>
                                {servicos.map((servico) => {
                                    const isChecked = !!servicosSelecionados[servico.id];

                                    return (
                                        <Grid item xs={12} sm={6} key={servico.id}>
                                            <Paper
                                                variant="outlined"
                                                sx={{
                                                    p: 1.5,
                                                    borderRadius: '12px',
                                                    borderColor: isChecked ? '#c084fc' : '#e2e8f0',
                                                    bgcolor: isChecked ? '#f3e8ff' : '#ffffff',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <Checkbox
                                                    checked={isChecked}
                                                    onChange={this.handleTransportadoraChange(servico.id)}
                                                    sx={{ color: '#9061f9', '&.Mui-checked': { color: '#7e22ce' } }}
                                                />
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a202c' }}>
                                                        {servico.company?.name || 'Transportadora'} — {servico.name}
                                                    </Typography>
                                                    <Typography variant="caption" color="textSecondary">
                                                        {servico.type === 'express' ? 'Entrega expressa' : 'Entrega padrão'}
                                                    </Typography>
                                                </Box>
                                            </Paper>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        )}
                    </>
                )}
            </Paper>
        );
    }
}

export default MelhorEnvioSection;